

const CreateImageSrc = (src) => {
    let newSrc;
    if (src){
    if (src.toString()?.startsWith('opt_')){
        newSrc=`${src.replace('opt_', 'th_')?.split('.')?.[0]}.webp`
    }else{
        newSrc=`th_${src?.replace('opt_', 'th_')?.split('.')?.[0]}.webp`
    }
}
    console.log("newSrc", newSrc)
    return newSrc;
//   return /^-?\d+$/.test(value);
};
export default CreateImageSrc;
